module.exports = __webpack_public_path__ + "img/Plan and Order.56ae288e.jpeg";